module.exports = __webpack_public_path__ + "static/media/OrderScreen.0ddeaa20.png";